import React from 'react'
import UserAvatarDropdown from './user-avatar-dropdown';
import Logo from '../logo';
import NotificationButton from '../notification-button';
import UploadQueueButton from './upload-queue-button';
import { SidebarTrigger } from '../ui/sidebar';

function Navbar() {
    return (
        <nav className={`navbar h-nav border-b px-dashboard flex items-center justify-between`}>
            <div className="flex items-center gap-4">
                <SidebarTrigger className="hidden md:flex" />
                <Logo className='md:hidden' />
            </div>
            <div className="flex items-center gap-2">
                <UploadQueueButton />
                <NotificationButton />  
                <UserAvatarDropdown />
            </div>
        </nav>
    )
}


export default Navbar
